import React from "react"
import LoanCommissionForm from "./Form"

export default function CreateLoanCommission() {
  return <LoanCommissionForm />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanCommission/Create.js